import { render, staticRenderFns } from "./CreateRoles.vue?vue&type=template&id=b84594f0"
import script from "./CreateRoles.vue?vue&type=script&lang=js"
export * from "./CreateRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports